const references = {
  RN: {
    reference:
      "Nykänen, R. 2010. Elämä tautisessa kaupungissa – Mustan surman vaikutus toscanalaiskaupunkien arkeen. Historian Pro Gradu -tutkielma. Humanistinen tiedekunta. Tampere: Tampereen yliopisto. Viitattu 28.10.2020.",
    link: "https://trepo.tuni.fi/bitstream/handle/10024/81816/gradu04473.pdf",
  },
  CBC: {
    reference:
      "Benedictow, O. J.; Bianucci, R. & Cesana, D. 2016. The origin and early spread of the Black Death in Italy: first evidence of plague victims from 14th-century Liguria (northern Italy). Viitattu 28.10.2020.",
    link:
      "https://www.jstage.jst.go.jp/article/ase/advpub/0/advpub_161011/_pdf",
  },
  B: {
    reference:
      "Britannica. Black Death - Cause and outbreak. Viitattu 15.11.2020",
    link: "https://www.britannica.com/event/Black-Death/Cause-and-outbreak",
  },
  PTH: {
    reference:
      "Heikura, P. T. 2003. Musta surma. Tieteessä Tapahtuu, 21(8). Viitattu 27.10.2020.",
    link: "https://journal.fi/tt/article/view/57247",
  },
  JF: {
    reference:
      "Frith, J. 2012. The History of Plague – Part 1. The Three Great Pandemics. Journal of Military and Verans’ Health, 20(2). Viitattu 28.10.2020.",
    link:
      "https://jmvh.org/article/the-history-of-plague-part-1-the-three-great-pandemics/",
  },
  KC: {
    reference:
      "Kjaer, C. 2019. Tutkijat paljastavat: Täältä musta surma alkoi. Tieteen Kuvalehti. Viitattu 28.10.2020.",
    link:
      "https://tieku.fi/laaketiede/sairaudet/tutkijat-paljastavat-taalta-musta-surma-alkoi",
  },
  JPG: {
    reference:
      "Glutting, J. P. 2013. Barcelona in the Plague Years. Barcelona Metropolitan. Viitattu 21.11.2020.",
    link: "https://www.barcelona-metropolitan.com/features/the-plague-years/",
  },
  MS: {
    reference:
      "Snell, M. 2019. The Arrival and Spread of the Black Plague in Europe. ThoughtCo. Viitattu 14.10.2020.",
    link:
      "https://www.thoughtco.com/spread-of-the-black-death-through-europe-4123214",
  },
  NR: {
    link: "https://www.visualcapitalist.com/medieval-trade-route-map/",
    author: "Routley, N.",
    contentName:
      "A Fascinating Map of Medieval Trade Routes. Viitattu 18.11.2020.",
  },
  A: {
    reference: "Asikkala. 2018. Perustietoa Asikkalasta. Viitattu 15.11.2020.",
    link: "https://www.asikkala.fi/perustietoa-asikkalasta/",
  },
  JS: {
    reference:
      "John Seven. 2020. The Black Death: A Timeline of the Gruesome Pandemic. History. Viitattu 18.11.2020.",
    link: "https://www.history.com/news/black-death-timeline",
  },
  RJE: {
    reference:
      "Professor Sir Evans, R. J. FBA. 2012. The Black Death. Gresham College. Viitattu 19.11.2020.",
    link: "https://www.youtube.com/watch?v=_5ImYgBeBS0",
  },
  MI: {
    reference: "Dr. Mike Ibeji. 2011. Black Death. BBC. Viitattu 18.11.2020.",
    link: "https://www.bbc.co.uk/history/british/middle_ages/black_01.shtml",
  },
  CW: {
    reference:
      "Curtis Williams. 2016. Weymouth and the Black Death. We are Weymouth. Viitattu 18.11.2020.",
    link:
      "https://www.weareweymouth.co.uk/attractions-sights/historic-buildings-country-houses/weymouth-and-the-black-death/",
  },
  JK: {
    reference:
      "John Kelly. 2005. The Great Mortality: An Intimate History of the Black Death, the Most Devastating Plague of All Time. HarperCollins Publishers. Viitattu 20.11.2020.",
    link: "",
  },
  HR: {
    reference:
      "Herman Rosenthal. 1906. CASIMIR III., THE GREAT (Polish, Kazimierz). Jewish Encyclopedia. Viitattu 20.11.2020.",
    link: "http://jewishencyclopedia.com/articles/4098-casimir-iii-the-great",
  },
  NFC: {
    reference:
      "Norman F. Cantor. 2001. In the wake of the plague : the Black Death and the world it made. The Free Press. Viitattu 21.11.2020.",
    link: "",
  },
  TK: {
    reference:
      "Tilastokeskus. 2019. Syntyvyyden aleneminen hidastui vuonna 2019. Viitattu 15.11.2020.",
    link:
      "https://www.stat.fi/til/synt/2019/synt_2019_2020-04-24_tie_001_fi.html",
  },
};

export default references;
